export default __webpack_public_path__ + "static/media/moonset.ea1519f7.png";